module.exports = __webpack_public_path__ + "media/images/sharing/energiefranken-og-de-6a9e0cae7920c1681d659a8e6c34aa48.png";